import { listTestimonies } from "@/api/testimonies";
import { useResource } from "@/hooks/useResource";
import { Button } from "@/components/ui/Button";
import { Badge, Container, Eyebrow, SkeletonCards } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { Icon } from "@/components/ui/Icon";

/**
 * Testimonies. Only real testimonies (API or curated) are shown; sample placeholders appear only
 * when explicitly enabled and are labelled. With none, an invitation to share takes their place.
 */
export function Testimonies() {
  const res = useResource("testimonies", (signal) => listTestimonies(signal));
  const items = res.data ?? [];

  return (
    <section className="testi" aria-labelledby="testi-title">
      <Container>
        <div className="testi__head">
          <Reveal>
            <Eyebrow index="09">Testimonies</Eyebrow>
          </Reveal>
          <Reveal delay={60}>
            <h2 id="testi-title" className="testi__title">
              Changed lives <em>tell the story.</em>
            </h2>
          </Reveal>
        </div>
        {res.data === undefined ? <SkeletonCards count={3} variant="text" /> : null}
        {items.length ? (
          <div className="testi__rail" role="region" aria-label="Testimonies" tabIndex={0}>
            {items.map((t, i) => (
              <Reveal as="figure" key={t.id} delay={i * 80} className="testi-card">
                {t.isSample ? <Badge tone="sample">Sample — replace</Badge> : null}
                <Icon name="quote" size={34} className="testi-card__mark" />
                <blockquote className="testi-card__quote">{t.quote}</blockquote>
                <figcaption className="testi-card__who">
                  <span className="testi-card__name">{t.name}</span>
                  {t.context ? <span className="testi-card__ctx">{t.context}</span> : null}
                </figcaption>
              </Reveal>
            ))}
          </div>
        ) : null}
        {res.data !== undefined ? (
          <Reveal className="testi__invite" variant="scale">
            <div>
              <p className="testi__invite-title">{items.length ? "What has God done for you?" : "Your story belongs here."}</p>
              <p className="testi__invite-text">
                Healing, breakthrough, restoration, salvation — every testimony strengthens someone's faith. Share yours with the church.
              </p>
            </div>
            <Button to="/testimonies" variant="primary" icon="message">
              Share your testimony
            </Button>
          </Reveal>
        ) : null}
      </Container>
    </section>
  );
}
